<template>
  <div class="app">
    <nav v-if="!$route.meta.hideNavbar" class="navbar">
      <div class="logo">养只啵啵鼻</div>
      <div class="nav-links">
        <router-link to="/">主页</router-link>
        <router-link to="/services">服务</router-link>
        <a href="#about">关于</a>
        <a href="#contact">联系我们</a>
      </div>
    </nav>

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app {
  font-family: 'Arial', sans-serif;
  background-color: #000000;
  color: white;
}

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 5%;
  background: #000000;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

.logo {
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.nav-links a,
.nav-links router-link {
  text-decoration: none;
  color: #E5E7EB;
  padding: 0.5rem 1rem;
  border-radius: 20px;
  transition: all 0.3s ease;
  font-weight: 500;
}

.nav-links a:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.router-link-active {
  color: white !important;
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.nav-links a[href="#contact"] {
  background-color: #3B82F6;
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 20px;
  border: 1px solid #3B82F6;
}

.nav-links a[href="#contact"]:hover {
  background-color: #2563EB;
  border-color: #2563EB;
}

@media (max-width: 768px) {
  .nav-links {
    gap: 0.5rem;
  }

  .nav-links a,
  .nav-links router-link {
    padding: 0.4rem 0.8rem;
    font-size: 0.9rem;
  }
}

.hero {
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: linear-gradient(
    rgba(0, 0, 0, 0.6),
    rgba(0, 0, 0, 0.1)
  ), url('./assets/healthcare-bg1.jpg');
  background-size: cover;
  background-position: center;
  color: white;
}

.hero h1,
.hero p {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.hero h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.cta-button {
  margin-top: 2rem;
  padding: 1rem 2rem;
  font-size: 1.2rem;
  background: #3B82F6;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.cta-button:hover {
  background: #2563EB;
}

.services {
  padding: 5rem 5%;
  text-align: center;
  background-color: #000000;
}

.service-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.service-card {
  padding: 2rem;
  background: #1F2937;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.2);
  color: white;
  transition: transform 0.3s ease;
}

.service-card:hover {
  transform: translateY(-5px);
}

.service-card h3 {
  margin-bottom: 1rem;
  color: white;
}

.service-card p {
  color: #E5E7EB;
}
</style>
